function isEmptyOrWhitespace(value) {
    var str = value.toString()

    return str === null || str.trim() === "";
}

function isNumber(value) {
    return /^\d+$/.test(value);
}

function isPhoneNumber(value) {
    return isNumber(value) && value.toString().length == 11
}

function isBoxNumber(value) {
    var urls = value.split("/")
    return urls.length >= 4 && urls[2] == "machine.goldbox.vip" && /[a-z]/.test(urls[urls.length - 1])
}

function parseBoxNumber(value) {
    var urls = value.split("/")

    return urls[urls.length - 1]
}

function isCupboardNumber(url) {
    var urls = url.split("/")
    return urls.length >= 4 && urls[2] == "consumer.goldbox.vip" && /[A-Z]/.test(urls[urls.length - 1])
}

export {
    isEmptyOrWhitespace,
    isNumber,
    isPhoneNumber,
    isBoxNumber,
    isCupboardNumber,
    parseBoxNumber
}
